/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import withRouter from "../WithRouter";
import axios from "axios";
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
import SpecialRequirements from "../common/SpecialRequirementsTooltip.js";
import ReturnButton from "../common/ReturnButton";
import LoadingSpinner from "../LoadingSpinner";
//Packages
import { Container, Col, Row, Table, Button } from "react-bootstrap";
// Router
import { isAuthenticatedTutor } from "./services/TutorAuth"; //import auth
import { Link, Navigate, useNavigate } from "react-router-dom";
//TimeRendering
import Moment from "react-moment";
// Subcomponents
import AddAttendanceNote from "./page-parts/AddAttendanceNote";
import RegisterDateBlock from "./page-parts/RegisterDateBlock";

const TutorBlockRegister = (props) => {
  const [blockData, setBlockData] = useState("");
  const [attendees, setAttendees] = useState([]);
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Initial Data
  const navigate = useNavigate();
  const blockid = props.params.blockid;
  const prevBlock = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevBlock.current = blockid; // Assign Refs Value to current load
    // Get the Register Data
    const getRegisterData = await axios.get(`/api/tutor/manage/block-registers/${blockid}`, {
      withCredentials: true,
    });
    setAttendees(getRegisterData.data.attendees);
    return setBlockData(getRegisterData.data.blockInfo);
  }, [blockid]); // Run useEffect when the classID changes to get new class data.

  // Get New Data when required
  const fetchNewData = async () => {
    // Get the Register Data
    const getRegisterData = await axios.get(`/api/tutor/manage/block-registers/${blockid}`, {
      withCredentials: true,
    });
    setAttendees(getRegisterData.data.attendees);
    return setBlockData(getRegisterData.data.blockInfo);
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='RegisterManage'>
      {blockData ? (
        <FadeIn delay={250} duration={450}>
          {isAuthenticatedTutor() ? (
            <Container>
              <Row className='mt-4 text-center'>
                <Col>
                  <h3>Register for {blockData.LessonType}</h3>
                  <p>
                    Held: {blockData.Venue.VenueName}
                    <br />
                    Starting: <Moment format='YYYY/MM/DD'>{blockData.Dates[0]}</Moment>
                  </p>
                </Col>
              </Row>
              {attendees.length > 0 ? (
                <>
                  <Row className='mt-3 mb-3 text-center'>
                    <Col>
                      <div>
                        <StatusBlock
                          errorMessage={errorMessage}
                          successMessage={successMessage}
                          dismissMessages={dismissMessages}
                        />
                      </div>
                      <Button
                        variant='info'
                        onClick={() => navigate(-1)}
                        size='sm'
                        className='mb-3 me-1'
                        type='link'
                      >
                        Return
                      </Button>
                      <Button
                        variant='success'
                        size='sm'
                        className='mb-3 ms-1'
                        as={Link}
                        to={`/tutor/blocks/${blockData._id}`}
                      >
                        Info
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <BlockRegisterTable
                        Participants={attendees}
                        SessionDates={blockData.Dates}
                        blockID={blockData._id}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        fetchNewData={fetchNewData}
                      />
                    </Col>
                  </Row>
                  <AddAttendanceNote
                    Participants={attendees}
                    registerid={blockData._id}
                    type='block'
                    secondSource={blockData._id}
                    submitClicked={submitClicked}
                    setSubmitClicked={setSubmitClicked}
                    setErrorMessage={setErrorMessage}
                    setSuccessMessage={setSuccessMessage}
                    fetchNewData={fetchNewData}
                  />
                </>
              ) : (
                <Row>
                  {" "}
                  <Col>
                    <p className='text-center'>
                      ...No Participants
                      <br />
                      <ReturnButton />
                    </p>
                  </Col>
                </Row>
              )}
            </Container>
          ) : (
            <Navigate to='/admin/' />
          )}
        </FadeIn>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

const BlockRegisterTable = (props) => {
  return (
    <Table striped bordered hover responsive className='text-center'>
      <thead>
        <tr>
          <th>Name</th>
          {props.SessionDates.map((item, i) => (
            <th key={i}>
              <strong>
                <Moment format='MM/DD'>{item}</Moment>
              </strong>
            </th>
          ))}
          <th>Note</th>
        </tr>
      </thead>
      <tbody>
        {props.Participants.sort((a, b) => {
          return a.Participant_Name.localeCompare(b.Participant_Name);
        }).map((Participant) => (
          <tr key={Participant._id}>
            <td td className='align-self-center align-middle'>
              {Participant.Participant_Name}
              {Participant.Special_Requirements && (
                <SpecialRequirements specialRequirements={Participant.Special_Requirements} />
              )}
              <br />
              <span className='smallprint'>{Participant.Status}</span>
              {Participant.Status !== "Adhoc!" && (
                <span className='smallprint'>
                  <br />(
                  <Moment format='Y [year], M [months]' durationFromNow ago>
                    {Participant.Participant_DoB}
                  </Moment>{" "}
                  old)
                </span>
              )}
            </td>
            {Participant.registerResults.map((registerResult, i) => (
              <RegisterDateBlock
                key={i}
                toRecord={registerResult.date}
                registerResult={registerResult}
                recordid={Participant._id}
                secondSource={props.blockID}
                type="block"
                submitClicked={props.submitClicked}
                setSubmitClicked={props.setSubmitClicked}
                setErrorMessage={props.setErrorMessage}
              />
            ))}
            <td td className='align-self-center align-middle'>
              {Participant.Attendance_Notes}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default withRouter(TutorBlockRegister);
